<template>
  <div class="Bottom">
    <div class="body">
      <div class="left">
        <div class="phone-logo">
          <img src="./img/phone.png" alt="" />
        </div>
        <div class="text ellipsis">
          <div class="text-t">联系我们</div>
          <div class="text-p">0571-88223392</div>
        </div>
      </div>
      <div class="c-line"></div>
      <div class="right">
        <ul class="ul" v-for="(item, index) of list" :key="index">
          <div class="title ellipsis">
            {{ item.name }}
          </div>
          <li class="li ellipsis" v-for="(items, index) in item.children" :key="index" @click="jump(items)">
            {{ items.name }}
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom">
      <div class="img">
        <img src="./img/badge.png" alt="" />
      </div>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo"> 浙公网安备 33010602011410号 </a>
      <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20024134号-1</a>
      <!-- <div style="width:300px;margin:0 auto;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <img src="./img/badge.png" style="float:left;" />
          <span style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33010602011410号</span>
        </a>
        <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
          <span>工信部备案号： 浙ICP备20024134号-1</span>
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Bottom',
  data() {
    return {
      list: [
        {
          name: '地图能力',
          children: [
            {
              name: '三维地图',
              route: '/ability/threeDimensional'
            },
            {
              name: '二维地图',
              route: '/ability/twoDimensional'
            },
            {
              name: '二三维一体化',
              route: '/ability/integrated'
            },
            {
              name: '倾斜摄影',
              route: '/ability/tiltPhotography'
            },
            {
              name: '2.5维地图',
              route: '/ability/tfDimensional'
            }
          ]
        },
        {
          name: '解决方案',
          children: [
            {
              name: '智慧城市',
              route: '/solve/city'
            },
            {
              name: '智慧旅游',
              route: '/solve/tourism'
            },
            {
              name: '美丽城镇',
              route: '/solve/town'
            },
            {
              name: '数字乡村',
              route: '/solve/village'
            },
            {
              name: '智慧园区',
              route: '/solve/park'
            }
          ]
        },
        {
          name: '客户案例',
          children: [
            {
              name: '智慧城市',
              route: '/case/wisdomCity'
            },
            {
              name: '全域旅游',
              route: '/case/globalTourism'
            },
            {
              name: '智慧景区',
              route: '/case/smartSpot'
            },
            {
              name: '美丽城镇',
              route: '/case/beautifulTown'
            },
            {
              name: '数字乡村',
              route: '/case/smartVillage'
            },
            {
              name: '智慧园区',
              route: '/case/smartPark'
            }
          ]
        },
        {
          name: '关于我们',
          children: [
            {
              name: '关于我们',
              route: ''
            }
          ]
        }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {
    //  路由跳转
    jump(items) {
      let { fullPath } = this.$route;
      if (!items.route) {
        return;
      }
      if (fullPath === items.route) {
        return;
      }
      this.$router.push({
        path: items.route
      });
      document.documentElement.scrollTop = 580;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.Bottom {
  width: 100%;
  // height: 510px;
  height: 400px;
  background: #282828;
  font-family: 'PingFang';
  box-sizing: border-box;
  padding-top: 40px;
  .body {
    display: flex;
    width: 100%;
    height: calc(100% - 60px);
    justify-content: center;
    .left {
      display: flex;
      .phone-logo {
        img {
          width: 40px;
        }
      }
      .text {
        margin-left: 39px;
        font-size: 24px;
        color: #fff;
        .text-t {
        }
        .text-p {
          margin-top: 20px;
        }
      }
    }
    .c-line {
      width: 1px;
      height: 240px;
      background: #979797;
      margin: 0 100px 0 50px;
    }
    .right {
      display: flex;
      color: #fff;
      font-size: 14px;
      .ul {
        margin-right: 90px;
        .title {
          font-size: 24px;
        }
        .li {
          margin-top: 20px;
          &:hover {
            color: #f15030;
            cursor: pointer;
          }
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 60px;
    background: #393838;
    text-align: center;
    line-height: 60px;
    color: #fff;
    font-size: 12px;
    .img {
      margin-right: px2rem(10rem);
      width: 18px;
      height: 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    a {
      margin-right: 10px;
      color: #fff;
    }
  }
}
</style>
